import { toast } from "react-toastify";
import { decryptUserInfo } from "../../sharedFiles/decryption/Decryption";
import { UseCart, useCart } from "./itemContext";
import { validateDecimalInput } from "../../sharedFiles/Helper/utils";
import { useEffect } from "react";

export const getDecryptedUser = () => {
  const user = sessionStorage.getItem("user");
  if (!user) return null;

  try {
    const encrypted = JSON.parse(user);
    return decryptUserInfo(encrypted); // <- return it
  } catch (err) {
    console.error("User decryption failed", err);
    return null;
  }
};

export const errorShowing = (error) => {
  const errorss = error;
  const status = errorss.errorCode;
  const errormessages = errorss.errorMessage;
  if (status) {
    toast.error(errormessages);
  } else {
    toast.error("Network Error");
  }
};

export const showSuccess = (error) => {
  toast.success("Order Successfully Placed");

};

export const convertColumnNameToPascalCase = (column) => {
  return column
    .replace(/_/g, ' ') // Replace underscores with spaces
    .replace(/\b\w/g, match => match.toUpperCase())
    .replace(/\s+/g, ' '); // Clean up multiple spaces
};

export const calculateGrandTotal = (cartItems) => {
  return cartItems.reduce((sum, item) => {
    console.log("tiotal",item);
    
    const total = parseFloat(item.total);
    return sum + (isNaN(total) ? 0 : total);
  }, 0).toFixed(2);
};

// export const handleDeleteRowCommon = ({
//   index,
//   cart,
//   setCartItems,
//   setRows,
//   setGrandTotal
// }) => {
//   const itemToDelete = cart[index];
//   console.log("itemToDelete :",itemToDelete);
// console.log("index :",index);
// console.log("cart :",cart);
// console.log("setCartItems :",setCartItems);
// console.log("setRows :",setRows);
//   // Guard clause: if item is invalid, do nothing
//   if (!itemToDelete || !itemToDelete.item_Code) {
//     console.warn("Invalid item at index", index);
//     return;
//   }
//   const itemCodeToRemove = itemToDelete.item_Code;
//   console.log("itemCodeToRemove",itemCodeToRemove);
  
//   setCartItems((prevCartItems) => {
//     const updatedCartItems = prevCartItems.filter(
//       (item) => item.item_Code !== itemCodeToRemove && Object.keys(item).length > 0
//     );
//     sessionStorage.setItem('cart', JSON.stringify(updatedCartItems));

//     const grandTotal = calculateGrandTotal(updatedCartItems);
//     setGrandTotal(grandTotal);

//     return updatedCartItems;
//   });
//   setRows((prevRows) => prevRows.filter((_, rowIndex) => rowIndex !== index));
// };

export const handleDeleteRowCommon = ({
  index,
  cart,
  setCartItems,
  setRows,
  setGrandTotal
}) => {
  const itemToDelete = cart[index];
  console.log("itemToDelete:", itemToDelete);
  console.log("index:", index);
  console.log("cart:", cart);

  // Guard clause: if index is out of bounds, do nothing
  if (index < 0 || index >= cart.length) {
    console.warn("Invalid index", index);
    return;
  }

  setCartItems((prevCartItems) => {
    // Remove item at the specified index
    const updatedCartItems = prevCartItems.filter((_, i) => i !== index);
    sessionStorage.setItem("cart", JSON.stringify(updatedCartItems));

    // Recalculate grand total for updated cart
    const grandTotal = calculateGrandTotal(updatedCartItems);
    setGrandTotal(grandTotal);

    return updatedCartItems;
  });

  // Also update rows by removing the row at the index
  setRows((prevRows) => prevRows.filter((_, rowIndex) => rowIndex !== index));
};

// export const useCartUtils = () => {
//   const { cart, setCartItems, setGrandTotal } = useCart();

//   const handleQuantityChange = (e, rowIndex, column, item = null) => {
//     console.log("e,",e);
//     console.log("rowIndex",rowIndex);
//     console.log("column",column);
//     console.log("item",item);

//     const inputValue = e.target.value; 
//     const { isValid, values: cleanedValue } = validateDecimalInput(inputValue);
//     if (!isValid) return;
//     const updatedCartItems = [...cart];
//     const currentRow = item || updatedCartItems[rowIndex];

    // const itemCode = currentRow?.item_Code;
    // const itemName = currentRow?.item_Name;

//     // if (!itemCode || !itemName) {
//     //   alert('Please select an item first before entering a quantity');
//     //   return;
//     // }
//     // const price = parseFloat(currentRow.discount_Price) || parseFloat(currentRow.price) || 0;
//     // const total = (price * cleanedValue).toFixed(2);
//     const price =parseFloat(currentRow.price_After_Discount) || parseFloat(currentRow.price) || 0;
//     const total = (price * cleanedValue).toFixed(2) ;
//     if (currentRow[column] === cleanedValue && currentRow.total === total) return;
//     updatedCartItems[rowIndex] = {
//       ...currentRow,
//       [column]: cleanedValue,
//       total:parseFloat(total)  };
//     const grandTotal = calculateGrandTotal(updatedCartItems);
//     setGrandTotal(grandTotal);
//     sessionStorage.setItem("cart", JSON.stringify(updatedCartItems));
//     setCartItems(updatedCartItems);
//   };

//   return { handleQuantityChange };
// };



 // Adjust imports

// export const useCartUtils = () => {
//   const { cart, setCartItems, setGrandTotal } = useCart();
//   const handleQuantityChange = (e, rowIndex, column, item = null) => {
//     const inputValue = e.target.value;
//     const { isValid, values: cleanedValue } = validateDecimalInput(inputValue);
//     if (!isValid) return;
//     setCartItems((prevCart) => {
//       const updatedCartItems = [...prevCart];
//       const currentRow = item || updatedCartItems[rowIndex];
//       const price = parseFloat(currentRow.price_After_Discount) || parseFloat(currentRow.price) || 0;
//       const total = (price * cleanedValue).toFixed(2);
//       if (
//         currentRow[column] === cleanedValue &&
//         currentRow.total === parseFloat(total)
//       ) {
//         return prevCart;
//       }
//       updatedCartItems[rowIndex] = {
//         ...currentRow,
//         [column]: cleanedValue,
//         total: parseFloat(total),
//       };
//       const grandTotal = calculateGrandTotal(updatedCartItems);
//       setGrandTotal(grandTotal);
//       sessionStorage.setItem("cart", JSON.stringify(updatedCartItems));
//       return updatedCartItems;
//     });
//   };
//   return { handleQuantityChange };
// };




export const useCartUtils = () => {
  const { cart, setCartItems, setGrandTotal } = useCart();

  const handleQuantityChange = (e, rowIndex, column, item = null) => {
    try {
      const inputValue = e.target.value;
      const { isValid, values: cleanedValue } = validateDecimalInput(inputValue);
      if (!isValid) return;

      setCartItems((prevCart) => {
        try {
          const updatedCartItems = [...prevCart];
          const currentRow = item || updatedCartItems[rowIndex];
          const price =
            parseFloat(currentRow.price_After_Discount) ||
            parseFloat(currentRow.price) ||
            0;

          const total = (price * cleanedValue).toFixed(2);

          if (
            currentRow[column] === cleanedValue &&
            currentRow.total === parseFloat(total)
          ) {
            return prevCart;
          }
          updatedCartItems[rowIndex] = {
            ...currentRow,
            [column]: cleanedValue,
            total: parseFloat(total),
          };
          const grandTotal = calculateGrandTotal(updatedCartItems);
          setGrandTotal(grandTotal);
          sessionStorage.setItem("cart", JSON.stringify(updatedCartItems));
          return updatedCartItems;
        } catch (innerErr) {
          console.error("Error inside setCartItems:", innerErr);
          return prevCart; // fallback to previous cart
        }
      });
    } catch (err) {
    
      return err; 
    }
  };

  return { handleQuantityChange };
};
